import { FC } from 'react';

import { NavLink } from 'react-router-dom';

import { RoutesUrls } from '~shared/lib/router';
import { EmailIcon, Image, PhoneIcon, Typography } from '~shared/ui';
import { dayjs } from '~shared/lib/time';
import { useTranslation } from '~shared/lib/i18n';
import defaultPhoto from '~shared/assets/defaultAvatar.svg';
import { timezoneDayjs } from '~shared/lib/utils';

import { IProfile } from '../../model/types';

const ApiUrl = import.meta.env.VITE_API_URL;
export interface ProfileCardViewProps {
  profile: IProfile;
}

export const ProfileCardView: FC<ProfileCardViewProps> = ({ profile }) => {
  const { t } = useTranslation();

  return (
    <div className="grid gap-9">
      <NavLink to={RoutesUrls.personal}>
        <p className="text-[18px] hover:text-blue-500">
          {' '}
          {profile.surname} {profile.name} {profile.patronymic ? profile.patronymic : ''}
        </p>
      </NavLink>
      <div className="rounded-[100px] overflow-hidden w-fit">
        <Image
          className="rounded-[90px]"
          width={90}
          height={90}
          src={`${ApiUrl}/kindergarten/profile/photo/sm/${profile.accelerator_foto}`}
          preview={{ src: `${ApiUrl}/kindergarten/profile/photo/lg/${profile.accelerator_foto}` }}
          fallback={defaultPhoto}
        />
      </div>
      <div className="grid gap-4">
        <Typography.Text>{timezoneDayjs(profile.birth_date).format('DD.MM.YYYY')}</Typography.Text>
        <Typography.Text>
          {t('profile:pin')} {profile.pin}
        </Typography.Text>
        <Typography.Text className="grid items-center grid-cols-[14px_1fr] gap-2.5">
          <EmailIcon /> {profile.email}
        </Typography.Text>
        <Typography.Text className="grid items-center grid-cols-[14px_1fr] gap-2.5">
          <PhoneIcon />
          {profile.telephone}
        </Typography.Text>
      </div>
    </div>
  );
};
